import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from "@angular/router";
import { UsuarioService } from '../../services/usuario.service';
import { AuthService } from '../../services/auth.service';
@Component({
    selector: 'app-usuario',
    templateUrl: './usuario.component.html',
    styleUrls: ['./usuario.component.css'],
    standalone: false
})
export class UsuarioComponent implements OnInit {
  total = 11;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;
  isVisibleDetalhe = false;
  infoUserLogado;
  usuarios = [];

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private usuarioService: UsuarioService,
    private authService: AuthService
  ) {
    this.authService.me().subscribe((m: any) => {
      this.infoUserLogado = m[0];
    }, (err: any) => {
      this.router.navigate(['/login']);
    });
  }

  ngOnInit(): void {
  }

  ativar(id) {
    let idLoading = this.message.loading('Ativando usuário...').messageId;
    this.usuarioService.ativar(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com SUCESSO!');
      this.loading = true;
      this.usuarioService.all(this.pageIndex).subscribe((m: any) => {
        this.usuarios = m.data.usuario.data;
        this.total = m.data.usuario.total;
        this.pageSize = m.data.usuario.per_page;
        this.loading = false;
      });
    });
  }

  /**
   * Inativa um usuário
   * 
   * @param id ID do usuário que será inativado
   * @param isRT True ou False, Passar como parametro se o usuário é RT ou não
   */
  inativar(id) {

    let idLoading = this.message.loading('Inativando usuário...').messageId;
    this.usuarioService.inativar(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com SUCESSO!');
      this.loading = true;
      this.usuarioService.all(this.pageIndex).subscribe((m: any) => {
        this.usuarios = m.data.usuario.data;
        this.total = m.data.usuario.total;
        this.pageSize = m.data.usuario.per_page;
        this.loading = false;
      });
    });

  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.usuarioService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.usuarios = m.data.usuario.data;
      this.total = m.data.usuario.total;
      this.pageSize = m.data.usuario.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchUsuario();
    this.isVisibleCancelFiltro = false;
  }

  searchUsuario() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true;    this.authService.me().subscribe((m: any) => {
        this.infoUserLogado = m[0];
      }, (err: any) => {
        this.router.navigate(['/login']);
      });
      this.usuarioService.all(this.pageIndex, this.search).subscribe((m: any) => {
        this.pageIndex = 1;
        this.usuarios = m.data.usuario.data;
        this.total = m.data.usuario.total;
        this.pageSize = m.data.usuario.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }


  closeModalDetalhe() {
    this.isVisibleDetalhe = false;
  }

}
